@if (isModal) {
  <ion-header>
    <ion-toolbar>
      <ion-back-button slot="start" (click)="back()" text=""></ion-back-button>
      <ion-title>Fehlerberichte senden</ion-title>
    </ion-toolbar>
  </ion-header>
}

<ion-content>
  <section>
    <!-- <ion-button (click)="sentrySrv.test()">Testfehler</ion-button> -->
    <h1>Fehlerberichte</h1>
    @if (!onlyText) {
      <div class="error-report-item">
        <div>
          <div class="error-report-header">Fehlerberichte senden</div>
          <p>
            Tragen Sie dazu bei die Qualität unserer Dienstleistungen zu verbessern. <br>
          </p>
        </div>
        <ion-toggle mode="ios" [(ngModel)]="sentrySrv.sentryEnabled" (ionChange)="sentrySrv.toggleSentryEnabled(sentrySrv.sentryEnabled)"></ion-toggle>
      </div>
    }

    <p>
      Um uns zu helfen, Probleme schnell zu beheben und die Qualität unserer App kontinuierlich zu verbessern, bieten wir Ihnen die Möglichkeit, uns bei der Fehlerberichterstattung zu unterstützen. Dabei werden technische Informationen über den Fehler und den Zustand der App erfasst und sicher an uns übermittelt. Wir verwenden hierfür den Dienst Sentry, und alle Daten werden ausschließlich auf Servern innerhalb der EU gespeichert, um den Datenschutzrichtlinien der EU und der DSGVO zu entsprechen.
      <br><br>
      Welche Daten werden gesendet?<br>
      Um die Fehlerursache zu identifizieren und zu beheben, werden folgende anonymisierte Daten erfasst:<br><br>
      - Geräteinformationen (z.B. Gerätetyp, Betriebssystem)<br>
      - App-Version<br>
      - App-Status (z.B. Absturz, Hängenbleiben, Code-Fehler)<br>
      - Fehlerprotokolle und -berichte<br><br>

      Keine persönlichen Daten werden weitergegeben. Sämtliche Informationen werden anonymisiert behandelt und ausschließlich zur Analyse und Verbesserung der App verwendet. Wir betonen, dass zu keiner Zeit ein Zugriff oder Einsicht auf Server-Informationen oder Ihre Datenbank besteht.
      <br><br>
      Die Zustimmung zur Fehlerberichterstattung ist optional, und die App kann auch ohne Zustimmung verwendet werden. Dennoch würde uns Ihre Unterstützung sehr helfen, um eine noch bessere App-Erfahrung zu gestalten und auftretende Probleme schnell zu beheben.
    </p>

  </section>
</ion-content>